import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPlusCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const SecureGuardCompliance = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const [connectedAccounts, setConnectedAccounts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newScan, setNewScan] = useState({ title: "", type: "", value: 0 });
  const [complianceData, setComplianceData] = useState([
    { id: 1, title: "Website Scan: example.com", value: 78, change: 12.8, slug: "example-com" },
    { id: 2, title: "Website Scan: testsite.com", value: 85, change: 15.2, slug: "testsite-com" },
    { id: 3, title: "URL Scan: api.example.com", value: 72, change: 10.3, slug: "api-example-com" },
    { id: 4, title: "Web Scan: myapp.com", value: 88, change: 17.5, slug: "myapp-com" },
    { id: 5, title: "URL Scan: secure.test.com", value: 80, change: 13.6, slug: "secure-test-com" },
  ]);

  const chartData = {
    series: [
      {
        name: "Health Score",
        data: complianceData.map((item) => item.value), // Flattened values
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      xaxis: {
        categories: complianceData.map((item) => item.title), // Titles as categories
        title: {
          text: "Scanned Websites/URLs",
        },
      },
      yaxis: {
        min: 60,
        max: 100,
        title: {
          text: "Health Score (%)",
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "30%",
          distributed: true, // Separates bars for each title
        },
      },
      colors: ["#6D5BFF", "#F4A261", "#4caf50", "#ff5733", "#ff9800"],
      dataLabels: {
        enabled: true,
        style: {
          colors: ["#fff"],
        },
      },
      legend: {
        show: false,
      },
    },
  };
  

  const handleCardClick = (slug) => {
    const sanitizedSlug = slug.replace(/^(https?:\/\/)/, "").replace(/\//g, "-");
    navigate(`/dashboard/secureguard/compliance/${sanitizedSlug}`);
  };

  const handleAddScan = () => {
    const newId = complianceData.length + 1;
    const newSlug = newScan.title
      .toLowerCase()
      .replace(/^(https?:\/\/)/, "")
      .replace(/\s+/g, "-")
      .replace(/\//g, "-");
    const updatedData = [...complianceData, { ...newScan, id: newId, slug: newSlug }];
    setComplianceData(updatedData);
    setShowModal(false);
    setNewScan({ title: "", type: "", value: 0 });
  };
  useEffect(() => {
    // Retrieve connected accounts from localStorage
    const accounts = localStorage.getItem("connectedAccounts");
    setConnectedAccounts(accounts ? JSON.parse(accounts) : []);
  }, []);

  const handleConnectAccount = () => {
    // Navigate to the "Connect Account" page
    navigate("/dashboard/connected-accounts");
  };
  if (!connectedAccounts || connectedAccounts.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center vh-100"
        style={{
          backgroundImage: 'url("/images/blurred_image.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="text-center text-dark p-4"
          style={{ backgroundColor: "rgba(170, 172, 242, 0.33)", borderRadius: "8px" }}
        >
          <h3>No Connected Accounts Found</h3>
          <p>
            To access this dashboard, please connect at least one account.
            Click the button below to get started.
          </p>
          <button className="btn text-white mt-3" style={{backgroundColor : '#342ead'}}
            onClick={handleConnectAccount}
          >
            Connect Account
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
    className="cloudmap-page container-fluid pb-5"
    style={{
      marginLeft: isSidebarOpen ? "0px" : "0px",
      transition: "margin-left 0.3s ease",
    }}
  >
    <div className="container">
    <h2 className="text-muted mb-4" style={{ color: "#111" }}>
        SecureGuard - Website and URL Scans
      </h2>

      {/* Filters */}
      <div className="row g-3 align-items-center mb-5">
        {/* Date Picker */}
        <div className="col-12 col-sm-6 col-md-3">
          <input
            type="date"
            className="form-control"
            defaultValue="2024-01-01"
            style={{
              width: "100%",
            }}
          />
        </div>

        {/* Scans Dropdown */}
        <div className="col-12 col-sm-6 col-md-3">
          <select
            className="form-select"
            style={{
              width: "100%",
            }}
          >
            <option>All Scans</option>
          </select>
        </div>

        {/* Regions Dropdown */}
        <div className="col-12 col-sm-6 col-md-3">
          <select
            className="form-select"
            style={{
              width: "100%",
            }}
          >
            <option>All Regions</option>
          </select>
        </div>

        {/* Muted Findings Checkbox */}
        <div className="col-12 col-sm-6 col-md-3 d-flex align-items-center">
          <input type="checkbox" id="mutedFindings" />
          <label htmlFor="mutedFindings" className="ms-2">
            Include Muted Findings
          </label>
        </div>
      </div>

      {/* Card Grid */}
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {complianceData.map((data) => (
          <div className="col" key={data.id}>
            <div
              className="rounded p-3 shadow cursor-pointer"
              onClick={() => handleCardClick(data.slug)}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body" style={{ position: "relative" }}>
              <h5 className="fw-bold text-muted mb-1" style={{ color: "#333" }}>SecureGuard Scan</h5>
              <p className="text-muted mb-5" style={{ fontSize: "0.9rem" }}>{data.title}</p>
                <div className="mb-2">
                  <span className="badge" style={{ backgroundColor: "#666bff54", color:"#6D5BFF",fontWeight:"700",
                    position: "absolute",top: "0",right: "0", }}>+34%</span>
                </div>
                <p className="card-text text-muted mb-1 fw-bold">Health Score</p>
                <div className="progress mb-2">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${data.value}%` ,backgroundColor: "#666cff" }}
                    aria-valuenow={data.value}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <small className="text-muted">Impressions:</small> <span className="fw-bold text-muted">12.4k Visits</span>
                  </div>
                  <div className="fw-bold" style={{ color: "#2196f3" }}>⬆ {data.change}%</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Bar Chart Section */}
      <div className="mt-5 rounded shadow p-3">
      <h5 className="fw-bold text-muted mb-3" style={{ color: "#333" }}>SecureGuard Health Score Overview</h5>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={400}
        />
      </div>

      {/* Modal for Adding Scans */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Scan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Scan Title</label>
            <input
              type="text"
              className="form-control"
              value={newScan.title}
              onChange={(e) => setNewScan({ ...newScan, title: e.target.value })}
              placeholder="Enter Website or URL"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Scan Type</label>
            <select
              className="form-select"
              value={newScan.type}
              onChange={(e) => setNewScan({ ...newScan, type: e.target.value })}
            >
              <option value="">Select Type</option>
              <option value="Website Scan">Website Scan</option>
              <option value="URL Scan">URL Scan</option>
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddScan} disabled={!newScan.title || !newScan.type}>
            Add Scan
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </div>
  );
};

export default SecureGuardCompliance;
